/* eslint-disable camelcase */
import type { OrderCompletedOnlineProducts } from '@/Infrastructure/Utils/analytics/braze/braze.types.ts';
import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';
import { getProductAttribute } from '@/modules/shared/utils/getProductAttribute';
import { getProductBrand } from '@/modules/shared/utils/getProductBrand';
import { getProductCategory } from '@/modules/shared/utils/getProductCategory';
import { isProductSponsored } from '@/modules/shared/utils/getProductSponsored';

export const getOrderCompletedOnlineProduct = (
  item: CartLineItem
): OrderCompletedOnlineProducts => {
  const prices = item?.variant?.prices;

  const listPrice = prices?.regular?.value?.centAmount;
  const paymentMethod = prices?.paymentMethod;
  const method = paymentMethod?.method;
  const methodPrice = paymentMethod?.value?.centAmount;

  const cardPrice = method === 'cencosudCard' ? methodPrice : undefined;

  const cpayPrice = method === 'cencoPay' ? methodPrice : undefined;

  const finalPrice =
    prices?.offer?.value?.centAmount ?? prices?.regular?.value?.centAmount;

  const promotions =
    typeof listPrice === 'number' && typeof finalPrice === 'number'
      ? listPrice - finalPrice
      : undefined;

  return {
    list_price: listPrice,
    card_price: cardPrice,
    cpay_price: cpayPrice,
    final_price: finalPrice,
    sponsored_product: isProductSponsored(item),
    product_id: item?.variant?.sku,
    channel: 'web',
    brand: getProductBrand(item),
    product_name: item?.name,
    category: getProductCategory(item),
    image_url: item?.variant?.images?.[0]?.url,
    product_url: item?.variant?.sku
      ? `https://www.paris.cl/${item.variant.sku}.html`
      : undefined,
    department: getProductAttribute(item, 'departmentId'),
    family: getProductAttribute(item, 'familyId'),
    class: getProductAttribute(item, 'classId'),
    promotions
  };
};
